import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 36 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 30\" id=\"icon-share\"><path d=\"M24.976 13.209v6.49l11.013-9.85L24.975 0v6.535C8.455 6.422 7.423 19.63 7.423 19.63c7.114-8.136 17.553-6.422 17.553-6.422zM15.429 2.536a1.826 1.826 0 0 1-1.826 1.826H3.68V26.3L0 26.297V4.382l2.708-.02H.012V2.71a2 2 0 0 1 2-2h11.59c1.01 0 1.827.817 1.827 1.825zM.007 26.305h29.357V21.55a1.835 1.835 0 1 1 3.669 0v6.399a2 2 0 0 1-2 2H2.007a2 2 0 0 1-2-2v-1.645z\" fill=\"#FF5159\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol